import type { SignInIntent } from '../SignInModal'

export type TranslationStreamError = { type: string; message?: string }

export type TranslationErrorContext = {
  isPro: boolean
  isAuthed: boolean
  setError: (msg: string | null) => void
  setLimitReached: (v: boolean) => void
  openSignIn: (intent?: SignInIntent) => void
}

export function applyTranslationStreamError(
  err: TranslationStreamError,
  ctx: TranslationErrorContext,
): void {
  if (err.type === 'limit_reached') {
    if (ctx.isPro) {
      ctx.setError(err.message || 'Translation service is temporarily unavailable. Please try again.')
    } else {
      ctx.setLimitReached(true)
      ctx.setError(err.message || "You've used up this month's character allowance")
      // A signed-in free user gets the inline limit card in the result area
      // (its button opens the paywall); no modal opens by itself.
      if (!ctx.isAuthed) ctx.openSignIn('upgrade-free')
    }
  } else if (err.type === 'slang_limit') {
    // The web UI never sends mode: 'slang' anymore, but the API can still
    // return this for legacy/mobile-originated requests — show a plain
    // error, no paywall routing.
    ctx.setError(err.message || 'Translation service is temporarily unavailable. Please try again.')
  } else {
    ctx.setError(err.message || 'Translation failed')
  }
}
